import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NavLogin from 'components/navbar/NavLogin'
import loadable from '@loadable/component'
import { toggleModal, MODAL_FROM_CONTEXTS } from 'store/ui/actions'
import styles from './styles/NavButtons.css'
import FeatureDropdown from './FeatureDropdown'
import ResourceDropdown from './ResourceDropdown'
import HoverLink from './HoverLink'

const NavDropdown = loadable(() => import('components/navbar/NavDropdown'))
const FeedDropdown = loadable(() => import('components/navbar/FeedDropdown'))

export const NavButtons = ({ avatarBg = 'gray', buttonColor = 'transparent', staticPage }) => {
  const user = useSelector(({ ui: { user } }) => user)
  const navOpen = useSelector(({ ui: { navOpen } }) => navOpen)
  const dispatch = useDispatch()
  const [rendered, setRendered] = useState(false)

  useEffect(() => {
    setRendered(true)
  }, [])

  const toolsItems = [
    {
      name: 'Plans & Pricing',
      href: '/pricing'
    },
    {
      name: 'Search',
      href: '/search'
    },
    {
      name: 'Reference Check',
      onClick: () => dispatch(
        toggleModal(user?.email ? 'referenceCheck' : 'login', true, MODAL_FROM_CONTEXTS.REFERENCE_CHECK)
      )
    },
    {
      name: 'Create Dashboard',
      href: '/create-dashboard'
    },
    {
      name: 'Journals Index',
      href: '/journals'
    },
    {
      name: 'Affiliations Index',
      href: '/affiliations'
    },
    {
      name: 'Funding Institutions Index',
      href: '/institutions'
    },
    {
      name: 'Blog',
      href: 'https://scite.ai/blog'
    },
    {
      name: 'Help & FAQ',
      href: 'https://help.scite.ai/'
    }
  ]

  return (
    <div className={styles.navButtons}>
      <div className={styles.mobileHide}>
        <FeatureDropdown />
        <ResourceDropdown />
        <HoverLink to='/pricing'>Pricing</HoverLink>
        <HoverLink to='/blog'>Blog</HoverLink>
      </div>
      {user?.email && (
        <FeedDropdown />
      )}
      {rendered && (
        <NavDropdown
          className={styles.desktopHide}
          buttonColor={buttonColor}
          initialShow={navOpen}
          dropdownClassName={styles.linkItem}
          items={toolsItems}
          menuOffset={[-45, 26]}
        >
          <i className={styles.menuIcon} />
        </NavDropdown>
      )}
      <NavLogin avatarBg={avatarBg} buttonColor={buttonColor} showSignup={staticPage} />
    </div>
  )
}

export default NavButtons
